import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the user completes the sign up flow.
 * Event: dental_portal:office_signup:completed
 */
export function fireCompleted(): void {
  PosthogService.getInstance().track('dental_portal:office_signup:completed', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
